// src/composables/useStorage.ts
import { Preferences } from '@capacitor/preferences';

export function useStorage() {
  async function get<T>(key: string, fallback: T): Promise<T> {
    try {
      const { value } = await Preferences.get({ key });
      if (value !== null) {
        return JSON.parse(value) as T;
      }
    } catch {
      // fall back to localStorage
    }

    if (typeof window !== 'undefined') {
      try {
        const item = window.localStorage.getItem(key);
        if (item !== null) return JSON.parse(item) as T;
      } catch {
        // ignore
      }
    }

    return fallback;
  }

  async function set<T>(key: string, value: T): Promise<void> {
    const serialized = JSON.stringify(value);

    try {
      await Preferences.set({ key, value: serialized });
    } catch {
      // ignore
    }

    if (typeof window !== 'undefined') {
      try {
        window.localStorage.setItem(key, serialized);
      } catch {
        // ignore
      }
    }
  }

  return { get, set };
}